import styled, { css } from 'styled-components';

export const StyledGlobalWrapper = styled.div`${
  (props) => {
    const { styles } = props;
    const {
      color,
      inputsLabelsTextAlign,
      inputsBorderRadius,
      calendarBorderRadius,
      buttonsBorderRadius,
    } = styles.body || {};
    const {
      padding: containerPadding,
      margin: containerMargin,
      widgetContainerBorderRadius,
    } = styles.container || {};

    return css`
      input, select, textarea {
        border-radius: ${inputsBorderRadius}px !important;
      }
      
      button {
        border-radius: ${buttonsBorderRadius}px !important;
      }  

      .styled-select {
        .bta-react-select__control {
          border-radius: ${inputsBorderRadius}px;
        }
        span[class$="indicatorSeparator"] {
          background-color: ${color};
        }
        svg[class$="Svg"] {
          color: ${color};
        }
      }

      .select-block {
        .titles {
          display: inline-block;
          width: 100%;
          text-align: ${inputsLabelsTextAlign};
        }
      }  

      .widget-calendar-page-container {
        border-radius: ${widgetContainerBorderRadius}px;
        padding: ${containerPadding}px;
        margin: ${containerMargin}px;
      }

      .bta-calendar-widget .fc-list {
        border-radius: ${calendarBorderRadius}px;

        .fc-scroller {
          border-radius: ${calendarBorderRadius}px;
        }
      }

      table.fc-scrollgrid {
        border-radius: ${calendarBorderRadius}px;

        thead {
          td:last-child {
            border-radius: 0 ${calendarBorderRadius}px 0 0;
          }
        }

        tbody {
          tr:last-child {
            td:last-child {
              border-radius: 0 0 ${calendarBorderRadius}px ${calendarBorderRadius}px;
            }
          }
        }
    `;
  }
}`;
